import React, { useState } from "react";
import CustomHeaderTitleView from "presentational/common/CustomHeaderTitleView";
import ImageCropperPanel from "container/upload/ImageCropperPanel";
import ProfileImgSummaryPanel from "container/upload/ProfileImgSummaryPanel";
import TXT from "presentational/common/multinational/TXT";
import { useHistory } from "react-router-dom";
import config from "lib/fr-config";

const IMAGE_QUALITY = config.uploadImageQuality.profile;

function RootProfileImgUpload(props) {
  const [croppedImageDataURL, setCroppedImageDataURL] = useState(null);
  const [internalCropData, setInternalCropData] = useState(null);
  const [phase, setPhase] = useState("imageCrop");
  const [
    hasAddImageButtonClickedAtLeastOnce,
    setHasAddImageButtonClickedAtLeastOnce
  ] = useState(false);

  const history = useHistory();

  const goToImageCropPhase = () => {
    setPhase("imageCrop");
  };

  const goToSummaryPhase = () => {
    setPhase("summary");
  };

  const handleExitClick = () => {
    history.goBack();
  };

  const handleImageCrop = (croppedImageDataURL, internalCropData) => {
    setCroppedImageDataURL(croppedImageDataURL);
    setInternalCropData(internalCropData);
  };

  const handleAddImageBtnClick = () => {
    setHasAddImageButtonClickedAtLeastOnce(true);
  };

  return (
    <div>
      <CustomHeaderTitleView
        title={<TXT name="titleImgUpload_profile" />}
        displayOnMobile
        displayOnDesktop
      />
      {phase === "imageCrop" && (
        <ImageCropperPanel
          imageType="profile"
          internalCropData={internalCropData}
          resultImageQuality={IMAGE_QUALITY}
          onImageCrop={handleImageCrop}
          onCancelClick={handleExitClick}
          onNextClick={goToSummaryPhase}
          hasAddImageButtonClickedAtLeastOnce={
            hasAddImageButtonClickedAtLeastOnce
          }
          onAddImageBtnClick={handleAddImageBtnClick}
        />
      )}
      {phase === "summary" && (
        <ProfileImgSummaryPanel
          imageDataURL={croppedImageDataURL}
          onBackClick={goToImageCropPhase}
          onUploadComplete={handleExitClick}
        />
      )}
    </div>
  );
}

export default RootProfileImgUpload;
